import { gql } from '@apollo/client';

export const editCredGql = gql`
  mutation editCredOnContract(
    $contractId: String!
    $credential: CredentialInput!
  ) {
    editCredOnContract(contractId: $contractId, credential: $credential) {
      credentials {
        _id
        type
        provider
        value
        description
      }
    }
  }
`;
